export default __webpack_public_path__ + "static/media/cqueezeThumb.e827e121.png";